(function () {
  var DEBOUNCE_MS = 320;
  var SECTION_ID = 'blog-search-results';

  function listingRoot() {
    return document.querySelector('[data-blog-listing]');
  }

  function getParts(listing) {
    if (!listing) return null;
    return {
      listing: listing,
      defaults: listing.querySelector('[data-blog-listing-default]'),
      results: listing.querySelector('[data-blog-listing-results]'),
      status: listing.querySelector('[data-blog-listing-status]'),
    };
  }

  function setStatus(parts, message) {
    if (!parts || !parts.status) return;
    parts.status.textContent = message || '';
  }

  function showDefaults(parts) {
    if (!parts) return;
    parts.listing.classList.remove('is-searching');
    if (parts.defaults) parts.defaults.hidden = false;
    if (parts.results) {
      parts.results.hidden = true;
      parts.results.innerHTML = '';
    }
    setStatus(parts, '');
  }

  function showResults(parts, html, statusMessage) {
    if (!parts || !parts.results) return;
    parts.listing.classList.add('is-searching');
    if (parts.defaults) parts.defaults.hidden = true;
    parts.results.hidden = false;
    parts.results.innerHTML = html;
    setStatus(parts, statusMessage || '');
  }

  function extractSectionHtml(text) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var section = doc.querySelector('#shopify-section-' + SECTION_ID);
    if (section) return section.innerHTML;
    var fallback = doc.querySelector('[data-blog-search-results]');
    return fallback ? fallback.outerHTML : '';
  }

  function buildUrl(form, query) {
    var url = new URL(form.action, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'article');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('section_id', SECTION_ID);
    return url.toString();
  }

  function initForm(form) {
    if (!form || form.dataset.blogSearchBound) return;
    form.dataset.blogSearchBound = '1';

    var input = form.querySelector('.blog-hero__search-input, input[type="search"][name="q"]');
    if (!input) return;

    var parts = getParts(listingRoot());
    var timer = null;
    var abortController = null;
    var lastQuery = '';

    function runSearch(query) {
      query = (query || '').trim();
      parts = getParts(listingRoot()) || parts;

      if (!query) {
        lastQuery = '';
        if (abortController) abortController.abort();
        showDefaults(parts);
        form.classList.remove('is-loading');
        return;
      }

      if (query === lastQuery) return;
      lastQuery = query;

      if (abortController) abortController.abort();
      abortController = new AbortController();
      form.classList.add('is-loading');
      setStatus(parts, 'Searching…');

      fetch(buildUrl(form, query), {
        signal: abortController.signal,
        headers: { Accept: 'text/html' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(function (text) {
          var html = extractSectionHtml(text);
          if (!html) throw new Error('empty');
          var countEl = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-blog-search-count], [data-blog-search-empty]');
          showResults(parts, html, countEl ? countEl.textContent.trim() : 'Search results updated');
          form.classList.remove('is-loading');
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          form.classList.remove('is-loading');
          showResults(
            parts,
            '<p class="blog-search-results__empty">Something went wrong. Please try again.</p>',
            'Search failed'
          );
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearTimeout(timer);
      runSearch(input.value);
    });

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var value = input.value;
      timer = setTimeout(function () {
        runSearch(value);
      }, DEBOUNCE_MS);
    });

    input.addEventListener('search', function () {
      // Fired when the clear (x) control is used in some browsers
      if (!input.value.trim()) {
        clearTimeout(timer);
        runSearch('');
      }
    });
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-blog-hero-search]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
